

export default class InspirationTranslationResponse  {
	LangCode?: string = '';
	Text?: string = '';
	constructor(obj?: Partial<InspirationTranslationResponse>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
